// PATH: src/api/learning/learning.ts
import { useApiClient } from "../apiClients";

export const ENDPOINTS_LEARNING = {
  HEARTBEAT: "/api/learning/heartbeat",
};

/**
 * Signal de présence émis pendant qu'une leçon est visible.
 *
 * `event_id` est généré par le client : le serveur l'insère avec
 * `ON CONFLICT DO NOTHING`, un renvoi du même battement n'est donc jamais
 * compté deux fois.
 */
export type HeartbeatPayload = {
  event_id: string;
  lesson_id: number;
};

/**
 * Accès aux routes pédagogiques de tc_tilmicode_be.
 *
 * ATTENTION : comme tous les hooks d'API de l'application, l'objet renvoyé
 * change d'identité à chaque rendu (`useApiClient` n'est pas mémoïsé de bout en
 * bout). Ne jamais mettre `sendHeartbeat` dans un tableau de dépendances :
 * passer par une ref.
 */
export const useLearningApi = () => {
  const client = useApiClient("tilmicode");

  const sendHeartbeat = async (payload: HeartbeatPayload): Promise<void> => {
    await client.post(ENDPOINTS_LEARNING.HEARTBEAT, payload);
  };

  return { sendHeartbeat };
};
